import { render, staticRenderFns } from "./sideMenu_dynamic_desaturated.vue?vue&type=template&id=907acc66"
import script from "./sideMenu_dynamic_desaturated.vue?vue&type=script&lang=js"
export * from "./sideMenu_dynamic_desaturated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports